import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#000000FF",
    },
    primary: {
      main: "rgb(153, 27, 27)",
    },
    secondary: {
      main: "hsla(210, 19.2%, 20.4%, 1)",
    },
    common: {
      black: "hsla(206, 10.1%, 13.5%, 1)",
    },
  },
});
